// extracted by mini-css-extract-plugin
export default {"container":"che_30sZc","input":"che_inp_rrUMa","label":"che_lab_fzU-8"};